"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const ArrowDownward = createSvgIcon(
  <path
    d="M11.5 17.0788V5L12.5 5V17.0788L18.2923 11.2865L19 12L12 19L5 12L5.7077 11.2865L11.5 17.0788Z"
    fill="#1E2C3F"
  />,
  "ArrowDownward",
)

const ArrowDownwardIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <ArrowDownward sx={{ fill: _fill, ...sx }} {...rest} />
}

export default ArrowDownwardIcon
